import i18n from '@/i18n'

export function handle418Error(dispatch: any, error: any, title: string): boolean {
  if (error.status === 418) {
    dispatch('errorPopup/showPopup', {
      title,
      text: error.response?.data?.message || 'Unknown error',
      buttonLabel: i18n.global.t('localization.close'),
    }, { root: true })
    return true
  }
  return false
}
